<template>
  <el-row style="padding: 50px 50px 0px 50px;" v-loading.body="pageLoading">
    <el-row>
      <el-button @click="printInvoice">{{ generateCustomizeString('printInvoice') }}</el-button>
    </el-row>

    <!-- 订单信息 -->
    <!-- 订单标题 -->
    <el-row class="order-data">
      <el-col>
        <div class="grid-content bg-purple" style="padding-left: 30px;">
          <h4>{{generateCustomizeString('orderDetail')}}</h4>
        </div>
      </el-col>
      <!-- 第一部分信息 -->
      <el-col :span="12">
        <div class="grid-content bg-purple">
          <span class="title-label">{{generateCustomizeString('orderId')}}:</span>
          <span class="content-label">{{this.orderDetailData.out_trade_no}}</span>
        </div>
        <div class="grid-content bg-purple">
          <span class="title-label">{{generateCustomizeString('orderStatus')}}:</span>
          <span class="content-label">{{ this.orderDetailData['status_name_' + this.$store.state.app.language]}}</span>
        </div>
        <div class="grid-content bg-purple">
          <span class="title-label">{{generateCustomizeString('orderType')}}:</span>
          <span
            class="content-label"
            v-if="this.orderDetailData.is_agent_order === true"
          >{{ generateCustomizeString('agentOrder') }}</span>
          <span class="content-label" v-else>{{ generateCustomizeString('generalOrder') }}</span>
        </div>
        <div class="grid-content bg-purple">
          <span class="title-label">{{generateCustomizeString('customerId')}}:</span>
          <span
            class="content-label"
            v-if="this.orderDetailData.is_agent_order === true"
          >{{this.orderDetailData.customer_name}}</span>
          <span
            class="content-label"
            v-else
            style="color: #409EFF;"
            @click="viewCustomer(orderDetailData.customer_id)"
          >{{this.orderDetailData.customer_name}}</span>
        </div>
        <div class="grid-content bg-purple">
          <span class="title-label">{{generateCustomizeString('wechatName')}}:</span>
          <span
            class="content-label"
            v-if="this.wechatDetail.nickname"
          >{{this.wechatDetail.nickname}}</span>
          <span class="content-label" v-else>{{ generateCustomizeString('unbound') }}</span>
        </div>
      </el-col>
      <!-- 第二部分信息 -->
      <el-col :span="12">
        <div class="grid-content bg-purple">
          <span class="title-label">{{generateCustomizeString('orderFee')}}:</span>
          <span class="content-label">{{this.orderDetailData.fee | formatPrice}}</span>
          <span
            style="margin-left: 20px;"
            v-if="this.orderDetailData.is_agent_order === true"
          >{{generateCustomizeString('agentProfit')}}:</span>
          <span
            class="content-label"
            v-if="this.orderDetailData.is_agent_order === true"
          >{{this.orderDetailData.profit | formatPrice}}</span>
        </div>
        <div class="grid-content bg-purple">
          <span class="title-label">{{generateCustomizeString('paymentDetail')}}:</span>
          <span class="content-label">
            <el-button
              size="medium"
              @click="viewPaymentDetail"
            >{{ generateCustomizeString('viewPaymentDetail') }}</el-button>
          </span>
        </div>
        <div class="grid-content bg-purple">
          <span class="title-label">{{generateCustomizeString('agentName')}}:</span>
          <span
            class="content-label"
            v-if="this.orderDetailData.is_agent_order === true"
            @click="viewAgent(orderDetailData.shop_id)"
            style="color: #409EFF;"
          >{{ this.orderDetailData.shop.display_shop_name }}</span>
          <span class="content-label" v-else>{{ generateCustomizeString('none') }}</span>
        </div>
        <div class="grid-content bg-purple">
          <span class="title-label">{{generateCustomizeString('customerRemark')}}:</span>
          <span
            class="content-label"
            v-if="this.orderDetailData.customer && this.orderDetailData.customer.remark"
          >{{ this.orderDetailData.customer.remark }}</span>
          <span class="content-label" v-else>{{ generateCustomizeString('none') }}</span>
        </div>
        <div class="grid-content bg-purple">
          <span class="title-label">{{generateCustomizeString('wechatImg')}}:</span>
          <span class="content-label" v-if="this.wechatDetail.headimgurl">
            <img
              :src="this.wechatDetail.headimgurl + '?imageView2/1/w/200/h/200/q/75|imageslim'"
              style="width:auto;height:40px;vertical-align: middle;"
            />
          </span>
          <span class="content-label" v-else>{{ generateCustomizeString('unbound') }}</span>
        </div>
      </el-col>

      <el-col style="padding: 0 30px;">
        <div class="grid-content bg-purple">
          <span class="title-label2">{{generateCustomizeString('customerMessage')}}:</span>
          <span
            style="padding-left: 10px; line-height: 26px;"
            v-if="this.orderDetailData.message"
          >{{this.orderDetailData.message}}</span>
          <span
            style="padding-left: 10px; line-height: 26px;"
            v-else
          >{{ generateCustomizeString('none') }}</span>
        </div>
        <div style="line-height: 50px;">
          <span class="title-label2">{{generateCustomizeString('isPickUp')}}:</span>

          <el-tag
            type="warning"
            style="margin-left:10px;"
            v-if="this.orderDetailData.is_pick_up === 1"
          >{{ generateCustomizeString('pickup') }}</el-tag>

          <el-tag style="margin-left:10px;" v-else>{{ generateCustomizeString('post') }}</el-tag>
        </div>
        <div style="padding: 0 40px;" v-if="this.orderDetailData.is_pick_up !== 1">
          <el-card shadow="never">
            <div slot="header" class="clearfix">
              <span>
                <b>{{generateCustomizeString('orderAddress')}}</b>
              </span>
              <el-button
                size="small"
                @click="updateOrderAddress"
                v-if="this.orderStatus < 20 && isEdit"
                style="margin-left: 20px;"
              >{{ generateCustomizeString('edit') }}</el-button>
            </div>
            <div>
              <el-table :data="orderAddressTable" tooltip-effect="dark" style="width: 100%">
                <el-table-column
                  prop="consignee_name"
                  :label="generateCustomizeString('shippingPerson')"
                ></el-table-column>
                <el-table-column prop="phone" :label="generateCustomizeString('recipientPhone')"></el-table-column>
                <el-table-column
                  prop="person_id"
                  :label="generateCustomizeString('identityNumber')"
                  min-width="120"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.person_id">{{scope.row.person_id}}</span>
                    <span v-else>{{ generateCustomizeString('none') }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="address_detail"
                  :label="generateCustomizeString('shippingAddress')"
                  min-width="280"
                ></el-table-column>
              </el-table>
            </div>
          </el-card>
          <el-card shadow="never" style="margin-top: 10px;">
            <div slot="header" class="clearfix">
              <span>
                <b>{{generateCustomizeString('orderSender')}}</b>
              </span>
            </div>
            <div>
              <el-table :data="orderSenderTable" tooltip-effect="dark" style="width: 100%">
                <el-table-column prop="sender_name" :label="generateCustomizeString('senderName')"></el-table-column>
                <el-table-column prop="phone" :label="generateCustomizeString('senderPhone')"></el-table-column>
                <el-table-column prop="address" :label="generateCustomizeString('senderAddress')"></el-table-column>
              </el-table>
            </div>
          </el-card>
        </div>
        <div style="padding: 0 40px;">
          <el-card shadow="never" style="margin-top: 10px;">
            <div slot="header" class="clearfix">
              <span>
                <b>{{generateCustomizeString('orderTime')}}</b>
              </span>
            </div>
            <div>
              <el-table :data="orderTimeTable" tooltip-effect="dark" style="width: 100%">
                <el-table-column
                  prop="created_at"
                  :label="generateCustomizeString('orderCreateAt')"
                >
                  <template slot-scope="scope">
                    <span>{{scope.row.created_at | toLocalTime}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="paid_at" :label="generateCustomizeString('paymentTime')">
                  <template slot-scope="scope">
                    <span v-if="scope.row.paid_at">{{scope.row.paid_at | toLocalTime}}</span>
                    <span v-else>{{ generateCustomizeString('none') }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="delivery_at"
                  :label="generateCustomizeString('deliveryTime')"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.delivery_at">{{scope.row.delivery_at | toLocalTime}}</span>
                    <span v-else>{{ generateCustomizeString('none') }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="finished_at"
                  :label="generateCustomizeString('completeTime')"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.finished_at">{{scope.row.finished_at | toLocalTime}}</span>
                    <span v-else>{{ generateCustomizeString('none') }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </div>
      </el-col>
    </el-row>

    <!-- 订单金额详情 -->
    <el-row class="order-data">
      <el-col>
        <div class="grid-content bg-purple" style="padding-left: 30px;">
          <h4>{{ generateCustomizeString('orderFeeDetai') }}</h4>
        </div>
      </el-col>
      <el-col style="padding: 10px 50px 0px 50px;" v-if="this.orderDetailData.order_fee_detail">
        <el-table :data="orderActivityData" tooltip-effect="dark" border style="width: 70%">
          <el-table-column align="center" :label="generateCustomizeString('orderActivity')">
            <template slot-scope="scope">
              <div v-if="scope.row.use_activity_list && scope.row.use_activity_list.length > 0">
                <div v-for="item in scope.row.use_activity_list" :key="item.id">
                  <div>{{item.title}}</div>
                </div>
              </div>
              <div v-else>{{generateCustomizeString('none')}}</div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            :label="generateCustomizeString('orderCoupon')"
            v-if="this.isCouponEnabled === 1"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.use_coupon_list && scope.row.use_coupon_list.length > 0">
                <div v-for="item in scope.row.use_coupon_list" :key="item.id">
                  <div>{{item.title}}</div>
                </div>
              </div>
              <div v-else>{{generateCustomizeString('none')}}</div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col style="padding: 30px 50px 0px 50px;" v-if="this.orderDetailData.order_fee_detail">
        <el-table :data="orderFeeDetail" tooltip-effect="dark" border style="width: 100%">
          <el-table-column
            align="center"
            prop="total_goods_fee"
            :label="generateCustomizeString('originalGoodsFee')"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="goods_fee"
            :label="generateCustomizeString('discountedGoodsFee')"
          >
            <template slot-scope="scope">
              <div>{{scope.row.total_goods_fee}}</div>
              <div
                v-if="scope.row.use_activity_list && scope.row.use_activity_list.length > 0"
              >- {{scope.row.total_activity_reduction + ' (' + generateCustomizeString('promotionActivity') + ')'}}</div>
              <div
                v-if="scope.row.use_coupon_list && scope.row.use_coupon_list.length > 0"
              >- {{scope.row.total_coupon_reduction + ' (' + generateCustomizeString('couponActivity') + ')'}}</div>
              <div
                v-if="scope.row.use_coupon_list.length > 0 || scope.row.use_activity_list.length > 0"
              >= {{scope.row.total_goods_fee_after_discounted}}</div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="total_express_fee"
            :label="generateCustomizeString('originalShippingFee')"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="express_fee"
            :label="generateCustomizeString('discountedShippingFee')"
          >
            <template slot-scope="scope">
              <div>{{scope.row.total_express_fee}}</div>
              <div
                v-if="parseInt(scope.row.total_express_fee_reduction) !== 0"
              >- NZD ${{scope.row.total_express_fee_reduction + ' (' + generateCustomizeString('promotionActivity') + ')'}}</div>
              <div
                v-if="parseInt(scope.row.total_express_fee_reduction) !== 0"
              >= {{scope.row.total_express_fee_after_discounted}}</div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="fee"
            :label="generateCustomizeString('orderShopPrice')"
          >
            <template slot-scope="scope">
              <div>{{scope.row.total_goods_fee_after_discounted}} + {{scope.row.total_express_fee_after_discounted}}</div>
              <div>= {{scope.row.total_fee_after_discounted}}</div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col style="padding: 30px 50px 0px 50px;" v-else>
        <el-table :data="orderFeeData" tooltip-effect="dark" border style="width: 100%">
          <el-table-column
            align="center"
            prop="goods_fee_before_discounted"
            :label="generateCustomizeString('originalGoodsFee')"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="goods_fee"
            :label="generateCustomizeString('discountedGoodsFee')"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="express_fee_before_discounted"
            :label="generateCustomizeString('originalShippingFee')"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="express_fee"
            :label="generateCustomizeString('discountedShippingFee')"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="fee"
            :label="generateCustomizeString('orderFinalPrice')"
          ></el-table-column>
        </el-table>
      </el-col>
      <el-col style="padding: 30px 50px 0px 50px;" v-if="this.orderDetailData.order_fee_detail">
        <el-table :data="orderFeeDetail" tooltip-effect="dark" border style="width: 70%">
          <el-table-column
            align="center"
            prop="total_fee_after_discounted"
            :label="generateCustomizeString('orderShopPrice')"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="profit"
            :label="generateCustomizeString('agentProfit')"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="fee"
            :label="generateCustomizeString('orderFinalPrice')"
          >
            <template slot-scope="scope">
              <div>{{scope.row.total_fee_after_discounted}} + {{scope.row.profit}}</div>
              <div>= {{scope.row.fee}}</div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <!-- 快递信息 -->
    <el-row class="order-data" v-if="this.orderDetailData.is_pick_up === 0">
      <el-col>
        <div class="grid-content bg-purple" style="padding-left: 30px;">
          <h4>{{ generateCustomizeString('shippingInfo') }}</h4>
        </div>
      </el-col>
      <el-col style="padding: 0px 50px 0px 50px;">
        <el-table :data="orderExpressData" tooltip-effect="dark" style="width: 100%">
          <el-table-column prop="expressNumber" :label="generateCustomizeString('expressNumber')"></el-table-column>
          <el-table-column prop="expressCompany" :label="generateCustomizeString('expressCompany')"></el-table-column>
          <el-table-column prop="queryUrl" :label="generateCustomizeString('queryUrl')">
            <template slot-scope="scope">
              <span>
                <a
                  :href="scope.row.queryUrl"
                  target="_blank"
                  style="color: #409EFF;"
                >{{scope.row.queryUrl}}</a>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="express" :label="generateCustomizeString('express')">
            <template slot-scope="scope">
              <el-button @click="expressClick(scope.row)" type="text" size="small">查询物流</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog
          :title="generateCustomizeString('shippingInfo')"
          :visible.sync="expressInfoDialogVisible"
          width="60%"
          :append-to-body="true"
        >
          <p
            style="padding-left: 30px; font-size: 16px;"
          >{{ generateCustomizeString('expressCompany') }}:{{this.expressCompany}}</p>
          <p
            style="padding-left: 30px; font-size: 16px;"
          >{{ generateCustomizeString('expressNumber') }}:{{this.expressNumber}}</p>
          <el-table
            :data="expressInfoData"
            tooltip-effect="dark"
            style="width: 100%; margin-top: 20px;"
            v-loading="expressInfoLoading"
          >
            <el-table-column prop="expressTime" :label="generateCustomizeString('expressTime')"></el-table-column>
            <el-table-column
              prop="expressContext"
              :label="generateCustomizeString('expressContext')"
            ></el-table-column>
          </el-table>
        </el-dialog>
      </el-col>
    </el-row>

    <!-- 商品清单 -->
    <!-- 商品头部 -->
    <el-row class="order-data">
      <el-col>
        <div class="grid-content bg-purple" style="padding-left: 30px;">
          <h4>{{generateCustomizeString('productList')}}</h4>
        </div>
      </el-col>
      <el-col style="padding: 0px 50px 0px 50px;">
        <el-table
          :data="orderProductData"
          tooltip-effect="dark"
          style="width: 100%"
          v-loading.body="orderProductListLoading"
        >
          <el-table-column :label="generateCustomizeString('productThumbnail')">
            <template slot-scope="scope">
              <img :src="scope.row.productThumbnailUrl" style="width:auto;height:100px;" />
            </template>
          </el-table-column>
          <el-table-column prop="productTitle" :label="generateCustomizeString('productTitle')"></el-table-column>
          <el-table-column prop="productId" :label="generateCustomizeString('barcode')"></el-table-column>
          <el-table-column prop="bestBefore" :label="generateCustomizeString('bestUseBefore')"></el-table-column>
          <el-table-column prop="unitPrice" :label="generateCustomizeString('unitPrice')"></el-table-column>
          <el-table-column prop="amount" :label="generateCustomizeString('quantity')"></el-table-column>
          <el-table-column prop="total" :label="generateCustomizeString('total')"></el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <!-- 订单操作 -->
    <!-- 订单操作头部 -->
    <el-row class="order-data" v-if="isEdit">
      <el-col>
        <div class="grid-content bg-purple" style="padding-left: 30px;">
          <h4>{{generateCustomizeString('orderOperation')}}</h4>
        </div>
      </el-col>
      <!-- 订单操作表单信息 -->
      <el-col style="padding-left: 20px;">
        <el-form
          :model="orderOperationForm"
          :rules="rules"
          ref="orderOperationForm"
          label-width="10%"
          class="demo-orderOperationForm"
        >
          <el-form-item
            :label="generateCustomizeString('modifyAmountofGoods')"
            prop="modifyAmountofGoods"
          >
            <el-input
              v-if="this.orderStatus === 0 && this.orderDetailData.is_agent_order === false"
              v-model="orderOperationForm.goods_fee"
              style="width: 90%"
            ></el-input>
            <el-input v-else v-model="orderOperationForm.goods_fee" style="width: 90%" disabled></el-input>
          </el-form-item>
          <el-form-item
            :label="generateCustomizeString('modifyShippingFee')"
            prop="modifyShippingFee"
          >
            <el-input
              v-if="this.orderStatus === 0 && this.orderDetailData.is_agent_order === false"
              v-model="orderOperationForm.express_fee"
              style="width: 90%"
            ></el-input>
            <el-input v-else v-model="orderOperationForm.express_fee" style="width: 90%" disabled></el-input>
          </el-form-item>
          <!-- 商品相册 -->
          <!-- 编辑图片附件 -->
          <el-form-item
            v-if="(this.orderStatus === 15 || this.orderStatus === 20) && isEdit"
            :label="generateCustomizeString('modifyAttachment')"
            prop="modifyAttachment"
            v-loading.body="uploadImgLoading"
            :element-loading-text="generateCustomizeString('UploadingImg')"
          >
            <el-col>
              <el-row>
                <el-col
                  v-for="(item, index) in imageList"
                  :key="index"
                  style="width:16%; margin:0 .3%"
                  prop="images"
                >
                  <el-card :body-style="{ padding: '0px'}">
                    <div class="card-img" @click="viewImageClick(item)">
                      <img :src="item + '?imageView2/0/w/350/h/350/q/75|imageslim'" />
                    </div>
                    <div style="padding: 14px;">
                      <div class="bottom clearfix">
                        <el-button
                          type="text"
                          class="button"
                          @click="topClick(index)"
                        >{{generateCustomizeString('topButton')}}</el-button>
                        <el-button
                          type="text"
                          class="button"
                          @click="delClick(index)"
                        >{{generateCustomizeString('deleteButton')}}</el-button>
                      </div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
              <el-upload
                ref="imageUpload"
                action="https://upload-z2.qiniup.com"
                :drag="true"
                :on-success="handleAvatarSuccess"
                :on-error="handleError"
                :before-upload="beforeAvatarUpload"
                :data="qiniuData"
                :show-file-list="true"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  {{generateCustomizeString('dragFiles')}}
                  <em>{{generateCustomizeString('uploadFiles')}}</em>
                </div>
                <div class="el-upload__tip" slot="tip">{{ generateCustomizeString('jpgpngonly') }}</div>
              </el-upload>
            </el-col>
          </el-form-item>
          <el-card
            class="box-card"
            style="width: 93%; margin: 0 auto;"
            v-if="this.orderDetailData.is_pick_up === 0"
          >
            <div slot="header" class="clearfix">
              <span>{{ generateCustomizeString('shippingInfo') }}</span>
              <el-button
                style="float: right; padding: 3px 0"
                type="text"
                @click="addExpresses()"
              >{{ generateCustomizeString('addTrackingNumber') }}</el-button>
            </div>
            <el-table ref :data="orderOperationForm.expresses" highlight-current-row>
              <el-table-column type="index"></el-table-column>
              <el-table-column :label="generateCustomizeString('expressCompany')">
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.express_company_id"
                    :placeholder="generateCustomizeString('expressCompany')"
                    style="width: 90%;"
                  >
                    <el-option
                      v-for="item in expressCompanyOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column :label="generateCustomizeString('expressNumber')">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.express_number"
                    style="width: 95%;"
                    prop="expressNumber"
                    onkeyup="this.value = this.value.match(/^[a-zA-Z0-9,]+/)"
                    :placeholder="generateCustomizeString('expressNumber')"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column :label="generateCustomizeString('operate')" width="150">
                <template slot-scope="scope">
                  <el-button
                    @click="onDelete(scope.$index)"
                    type="text"
                    size="small"
                  >{{generateCustomizeString('delete')}}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-card>

          <el-form-item
            :label="generateCustomizeString('messageToCustomer')"
            prop="expressDetails"
            style="margin-top: 20px;"
          >
            <el-input
              type="textarea"
              autosize
              :placeholder="generateCustomizeString('pleaseEnter')"
              v-model="orderOperationForm.to_customer_message"
              style="width: 90%"
            ></el-input><br>
            <span class="display-notice">*{{ generateCustomizeString('displayInOrders') }}*</span>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('operationNotes')" prop="operationNotes">
            <el-input
              type="textarea"
              autosize
              :placeholder="generateCustomizeString('pleaseEnter')"
              v-model="orderOperationForm.comments"
              style="width: 90%"
            ></el-input><br>
            <span class="display-notice">*{{ generateCustomizeString('displayInOrderLogs') }}*</span>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('orderStatus')">
            <el-radio-group v-model="orderStatus" size="small">
              <el-radio-button
                :label="0"
                :disabled="this.checkUnpiadEnable()"
              >{{generateCustomizeString('unpaid')}}</el-radio-button>
              <el-radio-button :label="5" disabled >{{ generateCustomizeString('partialyPaid') }}</el-radio-button>
              <el-radio-button
                :label="10"
                :disabled="this.checkPiadEnable()"

              >{{generateCustomizeString('paid')}}</el-radio-button>
              <el-radio-button
                :label="15"
                :disabled="this.checkPickingEnable()"

              >{{generateCustomizeString('picking')}}</el-radio-button>
              <el-radio-button
                :label="20"
                :disabled="this.checkShippedEnable()"

              >{{generateCustomizeString('shipped')}}</el-radio-button>
              <el-radio-button
                :label="40" disabled >{{generateCustomizeString('transactionComplete')}}</el-radio-button>
              <el-radio-button
               :label="50" disabled >{{generateCustomizeString('requestARefund')}}</el-radio-button>
              <el-radio-button
                :label="60"
                :disabled="this.checkRefundCompletedEnable()"

              >{{generateCustomizeString('refundCompleted')}}</el-radio-button>
              <el-radio-button
                :label="51"
                :disabled="this.checkCancelRefundEnable()"

              >{{ generateCustomizeString('cancelRefund') }}</el-radio-button>
              <el-radio-button
                :label="97"
                :disabled="this.checkCloseEnable()"

              >{{generateCustomizeString('closed')}}</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item v-show="checkIsRefundShow()"
            :label="generateCustomizeString('refundType')"
          >
            <el-radio-group v-model="orderOperationForm.refund_type">
              <el-radio
                :label="1"
              >{{generateCustomizeString('refund2Credits')}}
              </el-radio>
              <el-radio
                :label="2"
              >{{generateCustomizeString('refund2OPM')}}
              </el-radio>
              <el-radio
                :label="3"
              >{{generateCustomizeString('refund2Offline')}}
              </el-radio>
            </el-radio-group>
            <div class="polipay-refund2OPM-alert warning" v-if="orderOperationForm.refund_type == refund2OPM && poliPaidTransaction">
              订单有POLi支付的部分，请在平台提交原路退款后，线下转账给用户POLi支付的金额 {{ poliPaidTransaction['fee'] / 100}} NZD
            </div>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('orderComment')" prop="orderComment">
            <el-input
              type="textarea"
              autosize
              :placeholder="generateCustomizeString('pleaseEnter')"
              v-model="orderOperationForm.order_comment"
              style="width: 90%"
            ></el-input><br>
            <span class="display-notice">*{{ generateCustomizeString('displayOrderComments') }}*</span>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="submitForm('orderOperationForm')"
              plain
            >{{ generateCustomizeString('submitOrderDetail') }}</el-button>
            <el-button
              v-if="this.orderStatus === 15"
              type="primary"
              @click="saveOrderInfo"
              plain
              style="margin-left: 20px;"
            >{{ generateCustomizeString('saveWithoutDispatch') }}</el-button>
            <el-button
              v-if="this.orderDetailData.is_pick_up === 1 && this.orderStatus === 10"
              type="primary"
              @click="writeOffClick"
              plain
              style="margin-left: 20px;"
            >{{ generateCustomizeString('writeOffButton') }}</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <el-row v-else>
      <el-row class="order-data">
        <el-col>
          <div class="grid-content bg-purple" style="padding-left: 30px;">
            <h4>{{generateCustomizeString('orderAttachment')}}</h4>
          </div>
        </el-col>
        <el-col style="padding: 0px 50px 0px 50px;">
          <el-row>
            <el-col
              v-for="(item, index) in imageList"
              :key="index"
              style="width:16%; margin:0 .3%"
              prop="images"
            >
              <el-card :body-style="{ padding: '0px'}">
                <div class="card-img" @click="viewAttachmentClick(item)">
                  <img :src="item + '?imageView2/0/w/350/h/350/q/75|imageslim'" />
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-row>

    <!-- 订单操作日志 -->
    <el-row class="order-data">
      <el-col>
        <div class="grid-content bg-purple" style="padding-left: 30px;">
          <h4>{{generateCustomizeString('orderOperationLog')}}</h4>
        </div>
      </el-col>
      <el-col style="padding: 0px 50px 0px 50px;">
        <el-table
          :data="orderOperationLog"
          tooltip-effect="dark"
          style="width: 100%"
          v-loading.body="orderOperationLogLoading"
        >
          <el-table-column prop="operator" :label="generateCustomizeString('operator')"></el-table-column>
          <el-table-column prop="operatingTime" :label="generateCustomizeString('operatingTime')">
            <template slot-scope="scope">
              <span>{{ scope.row.operatingTime | toLocalTime }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="operationalAttributes"
            :label="generateCustomizeString('operationalAttributes')"
          ></el-table-column>
          <el-table-column
            prop="operationDetails"
            :label="generateCustomizeString('operationDetails')"
          ></el-table-column>
          <el-table-column prop="operationNotes" :label="generateCustomizeString('operationNotes')"></el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-dialog
      :title="generateCustomizeString('writeOffDetail')"
      :visible.sync="writeOffDialogVisible"
      width="30%"
      :append-to-body="true"
    >
      <el-form ref="writeOffForm" :model="writeOffForm">
        <div style="margin: 0 30px;">
          <el-form-item style="margin-top: 10px;">
            <div style="text-align: center;">
              <el-button
                @click="writeOffDialogVisible = false"
                style="width: 80px;"
              >{{generateCustomizeString('cancel') }}</el-button>
              <el-button
                type="primary"
                @click="writeOffConfirm()"
                style="width: 80px; margin-left: 30px;"
              >{{generateCustomizeString('confirm') }}</el-button>
            </div>
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog
      :title="generateCustomizeString('orderAddressEdit')"
      :visible.sync="dialogEditAddressVisible"
      width="60%"
    >
      <el-form :model="orderAddress" label-width="70px">
        <el-row>
          <el-form-item :label="generateCustomizeString('shippingPerson')" prop="consignee_name">
            <el-input v-model="orderAddress.consignee_name"></el-input>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('phoneNumber')" prop="phone">
            <el-input v-model="orderAddress.phone"></el-input>
          </el-form-item>
          <el-form-item
            :label="generateCustomizeString('identityNumber')"
            prop="person_id"
            v-if="this.orderAddress.country === '中国' || this.orderAddress.country === 'China'"
          >
            <el-input v-model="orderAddress.person_id"></el-input>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('country')" prop="country">
            <el-select
              v-model="orderAddress.country"
              :placeholder="generateCustomizeString('pleaseSelect')"
            >
              <el-option
                v-for="item in countryOptions"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-col :span="8">
            <el-form-item :label="generateCustomizeString('province')" prop="state">
              <el-input v-model="orderAddress.state"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="generateCustomizeString('city')" prop="city">
              <el-input v-model="orderAddress.city"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="generateCustomizeString('district')" prop="district">
              <el-input v-model="orderAddress.district"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item
              :label="generateCustomizeString('contactAddress')"
              prop="shipping_address"
            >
              <el-input v-model="orderAddress.shipping_address"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: center; padding: 10px 0;">
        <el-button
          @click="dialogEditAddressVisible = false"
          style="width: 100px; margin-right: 30px;"
        >{{generateCustomizeString('cancel')}}</el-button>
        <el-button
          type="primary"
          @click="updateAddressClick"
          style="width: 100px;"
        >{{generateCustomizeString('update')}}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="generateCustomizeString('paymentDetail')"
      :visible.sync="dialogPaymentDetailVisible"
      width="80%"
    >
      <div style="padding: 30px 0;">
        <el-table
          :data="paymentDetail"
          tooltip-effect="dark"
          style="width: 100%"
          v-loading.body="paymentDetailLoading"
        >
          <el-table-column prop="paymentNo" :label="generateCustomizeString('orderId')" width="300"></el-table-column>
          <el-table-column prop="createdTime" :label="generateCustomizeString('createTime')">
            <template slot-scope="scope">{{ scope.row.createdTime | toLocalTime}}</template>
          </el-table-column>
          <el-table-column prop="paymentTime" :label="generateCustomizeString('paymentTime')">
            <template
              slot-scope="scope"
              v-if="scope.row.paymentTime"
            >{{ scope.row.paymentTime | toLocalTime}}</template>
          </el-table-column>
          <el-table-column prop="paymentType" :label="generateCustomizeString('payType')"></el-table-column>
          <el-table-column prop="paymentStatus" :label="generateCustomizeString('payStatus')"></el-table-column>
          <el-table-column prop="paymentFee" :label="generateCustomizeString('paymentAmount')"></el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
      :title="generateCustomizeString('modifyAttachment')"
      :visible.sync="viewImageVisible"
      width="60%"
    >
      <div>
        <img :src="viewImage" style="width: 100%;" />
      </div>
    </el-dialog>

    <el-dialog
      :title="generateCustomizeString('modifyAttachment')"
      :visible.sync="viewAttachmentVisible"
      width="60%"
    >
      <div>
        <img :src="viewAttachment" style="width: 100%;" />
      </div>
    </el-dialog>

    <el-dialog
      :title="generateCustomizeString('confirmSubmitOrderInfo')"
      :visible.sync="dialogSubmitOrderInfoVisible"
      width="30%"
    >
      <div style="text-align: center; padding: 10px 0;">
        <el-button
          @click="dialogSubmitOrderInfoVisible = false"
          style="width: 100px; margin-right: 30px;"
        >{{generateCustomizeString('cancel')}}</el-button>
        <el-button
          type="primary"
          @click="confirmSubmitOrderInfo('orderOperationForm')"
          style="width: 100px;"
        >{{generateCustomizeString('confirm')}}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="generateCustomizeString('confirmSaveOrderInfo')"
      :visible.sync="dialogSaveOrderInfoVisible"
      width="30%"
    >
      <div style="text-align: center; padding: 10px 0;">
        <el-button
          @click="dialogSaveOrderInfoVisible = false"
          style="width: 100px; margin-right: 30px;"
        >{{generateCustomizeString('cancel')}}</el-button>
        <el-button
          type="primary"
          @click="confirmSaveOrderInfo()"
          style="width: 100px;"
        >{{generateCustomizeString('confirm')}}</el-button>
      </div>
    </el-dialog>

    <print-invoice ref="printInvoice"></print-invoice>

    <el-button
      round
      type="primary"
      style="position: fixed; right: 50px; bottom: 50px; z-index: 10000;"
      icon="el-icon-arrow-left"
      @click="$router.go(-1)"
    >{{ generateCustomizeString('return') }}</el-button>
  </el-row>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import PrintInvoice from './PrintInvoice'
import imageConversion from 'image-conversion'

const defaultOrderOperation = {
  goods_fee: 0,
  express_fee: 0,
  expresses: [],
  to_customer_message: '',
  comments: '',
  status: 0,
  refund_type: '1', // 默认退回余额
  order_comment: ''
}
const defaultExpresses = {
  express_company_id: '',
  express_number: ''
}

export default {
  name: 'OrderDetail',
  components: {
    PrintInvoice
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      refund2Credits: 1,
      refund2OPM: 2,
      refund2Offline: 3,
      checked: true,
      status: 0,
      orderProductData: [],
      orderTransaction: [],
      orderDetailData: {
        created_at: '2019-01-01 00:00:00',
        delivery_at: '2019-01-01 00:00:00',
        finished_at: '2019-01-01 00:00:00'
      },
      orderFeeData: [],
      orderExpressData: [],
      expressInfoData: [],
      wechatDetail: [],
      orderAddress: [],
      orderSender: [],
      orderAddressTable: [],
      orderSenderTable: [],
      orderTimeTable: [],
      orderOperationLog: [],
      orderStatusCopy: '',
      imageList: [],
      imgListKey: [],
      uploadImgLoading: false,
      pageLoading: false,
      orderProductListLoading: false,
      orderOperationLogLoading: false,
      expressInfoLoading: false,
      orderOperationForm: Object.assign({}, defaultOrderOperation),
      dialogEditAddressVisible: false,
      dialogPaymentDetailVisible: false,
      paymentDetailLoading: false,
      expressInfoDialogVisible: false,
      viewImageVisible: false,
      viewAttachmentVisible: false,
      editOrderAddressForm: [],
      paymentDetail: [],
      expressCompanyOptions: [],
      expressCompany: '',
      expressNumber: '',
      countryOptions: [
        {
          value: '中国'
        },
        {
          value: '新西兰'
        }
      ],
      viewImage: '',
      viewAttachment: '',
      rules: {
        expressNumber: [
          {
            // required: true,
            pattern: '^[a-zA-Z0-9,s]+$',
            message: this.generateCustomizeString('IncorrectShippingId'),
            trigger: 'blur'
          }
        ]
      },
      qiniuData: {
        token: ''
      },
      isAgentRefundNo: '',
      isAgentPayType: '',
      orderFeeDetail: [],
      useActivityList: [],
      useCouponList: [],
      orderActivityData: [],
      isCouponEnabled: this.$store.state.shop.is_coupon_enabled,
      writeOffDialogVisible: false,
      writeOffForm: {
        orderId: '',
        id: ''
      },
      poliPaidTransaction: null,
      dialogSubmitOrderInfoVisible: false,
      dialogSaveOrderInfoVisible: false
    }
  },
  computed: {
    orderStatus: {
      get: function() {
        if (
          this.orderStatusCopy === 15 &&
          this.orderOperationForm.expresses.length > 0
        ) {
          return 20
        } else {
          return this.orderStatusCopy
        }
      },
      set: function(value) {
        this.orderStatusCopy = value
      }
    }
  },
  methods: {
    generateCustomizeString,
    checkUnpiadEnable: function() {
      if (this.status >= 90 && this.status !== 99) {
        return false
      } else {
        return true
      }
    },
    checkPiadEnable: function() {
      if (this.status === 0 || this.status === 5) {
        if (this.orderDetailData.is_agent_order === false) {
          return false
        } else {
          return true
        }
        // return false
      } else {
        return true
      }
    },
    checkPickingEnable: function() {
      if (this.status === 10 && !this.orderDetailData.is_pick_up) {
        return false
      } else {
        return true
      }
    },
    checkShippedEnable: function() {
      if (this.status === 10 || this.status === 15) {
        return false
      } else {
        return true
      }
    },
    checkRefundCompletedEnable: function() {
      if (this.status === 50) {
        return false
      } else {
        return true
      }
    },
    checkCancelRefundEnable: function() {
      if (this.status === 50) {
        return false
      } else {
        return true
      }
    },
    checkCloseEnable: function() {
      if (this.status === 20 || this.status === 40 || this.status === 50) {
        return true
      } else {
        return false
      }
    },
    checkIsRefundShow: function() {
      const flag1 =
        this.status === 5 || this.status === 10 || this.status === 15
      const flag2 = this.orderStatus === 97
      const flag3 = this.status === 50
      const flag4 = this.orderStatus === 60
      if ((flag1 && flag2) || (flag3 && flag4)) {
        return true
      } else {
        return false
      }
    },
    checkIsAgentRefundShow: function() {
      const flag1 =
        this.status === 5 || this.status === 10 || this.status === 15
      const flag2 = this.orderStatus === 97
      const flag3 = this.status === 50
      const flag4 = this.orderStatus === 60
      const isAgentOrder = this.orderDetailData.is_agent_order
      if (
        (flag1 && flag2 && isAgentOrder) ||
        (flag3 && flag4 && isAgentOrder)
      ) {
        return true
      } else {
        return false
      }
    },
    viewCustomer(customerId) {
      this.$router.push({
        name: 'MemberView',
        params: { memberId: customerId }
      })
    },
    viewAgent(agentId) {
      this.$router.push({
        name: 'EditAgent',
        params: { agentId: agentId }
      })
    },
    viewImageClick(item) {
      this.viewImageVisible = true
      this.viewImage = item + '?imageView2/0/w/800/h/800/q/75|imageslim'
    },
    viewAttachmentClick(item) {
      this.viewAttachmentVisible = true
      this.viewAttachment = item + '?imageView2/0/w/800/h/800/q/75|imageslim'
    },
    addExpresses() {
      this.orderOperationForm.expresses.push(
        Object.assign({}, defaultExpresses)
      )

      for (var j = 0; j < this.orderOperationForm.expresses.length; j++) {
        for (var i = 0; i < this.expressCompanyOptions.length; i++) {
          if (
            this.expressCompanyOptions[i].is_default === 1 &&
            this.orderOperationForm.expresses.length === 1
          ) {
            this.orderOperationForm.expresses[0].express_company_id = this.expressCompanyOptions[
              i
            ].value
          }
        }
      }
    },
    onDelete(index) {
      this.orderOperationForm.expresses.splice(index, 1)
    },
    expressClick(row) {
      this.expressInfoDialogVisible = true
      this.expressInfoLoading = true
      this.expressCompany = row.expressCompany
      this.expressNumber = row.expressNumber
      this.expressInfoData = []
      request({
        url: '/express/trace/detail',
        method: 'get',
        params: {
          express_number: row.expressNumber,
          express_company_id: row.expressCompanyId
        }
      })
        .then(response => {
          const expressInfo = []
          if (response.data.trades.length > 0) {
            for (var i = 0; i < response.data.trades.length; i++) {
              var obj = {}
              obj.expressTime = response.data.trades[i].time
              obj.expressContext = response.data.trades[i].context

              expressInfo[i] = obj
            }
          }
          this.expressInfoData = expressInfo
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.expressInfoLoading = false
        })
    },
    submitForm() {
      this.dialogSubmitOrderInfoVisible = true
    },
    confirmSubmitOrderInfo(formName) {
      this.updateOrderInfo()
    },
    saveOrderInfo() {
      this.dialogSaveOrderInfoVisible = true
    },
    confirmSaveOrderInfo() {
      if (this.orderDetailData.is_agent_order === true) {
        this.orderOperationForm.refund_type = this.refund2OPM
      }

      var data = {
        expresses: this.orderOperationForm.expresses,
        to_customer_message: this.orderOperationForm.to_customer_message,
        comments: this.orderOperationForm.comments
          ? this.orderOperationForm.comments
          : '',
        refund_type: this.orderOperationForm.refund_type,
        upload_image_keys: this.imgListKey,
        order_comment: this.orderOperationForm.order_comment
      }

      if (this.status === 0) {
        data['goods_fee'] = (this.orderOperationForm.goods_fee * 1000) / 10
        data['express_fee'] = (this.orderOperationForm.express_fee * 1000) / 10
      }

      request({
        url: 'order/' + this.$route.params.orderId,
        method: 'put',
        data
      })
        .then(response => {
          if (response.data.order_operation_logs) {
            const data = []
            for (
              let i = 0;
              i < response.data.order_operation_logs.length;
              i++
            ) {
              var obj = {}
              obj.operator = response.data.order_operation_logs[i].operator
              obj.operatingTime =
                response.data.order_operation_logs[i].created_at
              obj.operationalAttributes = this.getOperationStatus(
                response.data.order_operation_logs[i].status
              )
              obj.operationDetails =
                response.data.order_operation_logs[i].message
              obj.operationNotes =
                response.data.order_operation_logs[i].comments

              data[i] = obj
            }
            // this.orderOperationLog = data
          }
          this.orderDetailData.goods_fee = response.data.goods_fee
          this.orderDetailData.express_fee = response.data.express_fee
          if (response.status === 0) {
            this.dialogSaveOrderInfoVisible = false
            this.$message({
              message: this.generateCustomizeString('OrderDetailSaved'),
              type: 'success'
            })
            this.orderAddressTable = []
            this.orderSenderTable = []
            this.orderTimeTable = []
            this.orderFeeData = []
            this.fetchOrderInfo()
          } else {
            this.dialogSaveOrderInfoVisible = false
            this.$message.error(
              this.generateCustomizeString('OrderDetailSaveFailed')
            )
          }
        })
        .catch(error => {
          console.error(error)
          this.dialogSaveOrderInfoVisible = false
          this.$message.error(
            this.generateCustomizeString('OrderDetailSaveFailed')
          )
        })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    updateOrderAddress() {
      this.dialogEditAddressVisible = true
    },
    topClick(index) {
      this.uploadImgLoading = true
      var copyImageList = this.imageList.slice()
      var copyImageListKeys = this.imgListKey.slice()
      copyImageList.unshift(copyImageList.splice(index, 1)[0])
      copyImageListKeys.unshift(copyImageListKeys.splice(index, 1)[0])

      var data = {
        upload_image_keys: copyImageListKeys
      }

      request({
        url: 'order/' + this.$route.params.orderId + '/order-images',
        method: 'put',
        data
      })
        .then(response => {
          if (response.status === 0) {
            this.uploadImgLoading = false
            this.$message({
              message: this.generateCustomizeString('OrderImgSaved'),
              type: 'success'
            })
            this.imageList = copyImageList
            this.imgListKey = copyImageListKeys
          } else {
            this.uploadImgLoading = false
            this.$message.error(
              this.generateCustomizeString('OrderImgSaveFailed')
            )
          }
        })
        .catch(error => {
          console.log(error)
          this.uploadImgLoading = false
          this.$message.error(
            this.generateCustomizeString('OrderImgSaveFailed')
          )
        })
    },
    delClick(index) {
      this.uploadImgLoading = true

      var copyImageList = this.imageList.slice()
      var copyImageListKeys = this.imgListKey.slice()
      copyImageList.splice(index, 1)
      copyImageListKeys.splice(index, 1)

      var data = {
        upload_image_keys: copyImageListKeys
      }

      request({
        url: 'order/' + this.$route.params.orderId + '/order-images',
        method: 'put',
        data
      })
        .then(response => {
          if (response.status === 0) {
            this.uploadImgLoading = false
            this.$message({
              message: this.generateCustomizeString('OrderImgDeleted'),
              type: 'success'
            })
            this.imageList = copyImageList
            this.imgListKey = copyImageListKeys
          } else {
            this.uploadImgLoading = false
            this.$message.error(
              this.generateCustomizeString('OrderImgDeleteFailed')
            )
          }
        })
        .catch(error => {
          console.log(error)
          this.uploadImgLoading = false
          this.$message.error(
            this.generateCustomizeString('OrderImgDeleteFailed')
          )
        })
    },
    printInvoice() {
      this.$refs.printInvoice.handlePrintClick(this.$route.params.orderId)
    },
    // 订单状态:0未付款 10已付款（待发货）15配货中 20已发货（待完成）30未付款已发货 40交易完成 50申请退款 60退款完成 99已关闭
    getOperationStatus(status) {
      var statusName = ''
      switch (status) {
        case 1:
          statusName = this.generateCustomizeString('orderStatus')
          break
        case 2:
          statusName = this.generateCustomizeString('priceOfOrder')
          break
        case 3:
          statusName = this.generateCustomizeString('otherOperation')
          break
        default:
          statusName = this.generateCustomizeString('otherOperation')
      }
      return statusName
    },

    handleAvatarSuccess(res, file, fileList) {
      this.imageList.push('https://img.nzmai.com.cn/' + res.key)
      this.imgListKey.push(res.key)

      var data = {
        upload_image_keys: this.imgListKey
      }

      request({
        url: 'order/' + this.$route.params.orderId + '/order-images',
        method: 'put',
        data
      })
        .then(response => {
          if (response.status === 0) {
            this.uploadImgLoading = false
            this.$message({
              message: this.generateCustomizeString('OrderImgSaved'),
              type: 'success'
            })
          } else {
            this.uploadImgLoading = false
            this.$message.error(
              this.generateCustomizeString('OrderImgSaveFailed')
            )
            this.imgListKey.pop()
            this.imageList.pop()
          }
        })
        .catch(error => {
          console.log(error)
          this.uploadImgLoading = false
          this.$message.error(
            this.generateCustomizeString('OrderImgSaveFailed')
          )
          this.imgListKey.pop()
          this.imageList.pop()
        })

      this.$refs.imageUpload.clearFiles()
    },
    handleError(res) {
      // 显示错误
      console.log(res)
    },
    beforeAvatarUpload(file) {
      return new Promise((resolve, reject) => {
        const isJPG = file.type === 'image/jpeg'
        const isPNG = file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < 4

        if (!isJPG && !isPNG) {
          this.$message.error(this.generateCustomizeString('jpgpngonly'))
        } else {
          if (isLt2M) {
            resolve(file)
            this.uploadImgLoading = true
          }
        }

        // 压缩到400KB,这里的400就是要压缩的大小,可自定义
        imageConversion.compressAccurately(file, 400).then(res => {
          // console.log(res)
          resolve(res)
          this.uploadImgLoading = true
        })

        // return (isJPG || isPNG) && isLt2M
      })
    },
    handlePreview(file) {
      console.log(file)
    },
    getPaymentMethod(val) {
      var paymentMethod = ''
      switch (val) {
        case 'IE0011':
          paymentMethod = this.generateCustomizeString('alipayQrCode')
          break
        case 'IE0012':
          paymentMethod = this.generateCustomizeString('alipayOnline')
          break
        case 'IE0013':
          paymentMethod = this.generateCustomizeString('alipayMobileOnline')
          break
        case 'IE0021':
          paymentMethod = this.generateCustomizeString('wechatQrCode')
          break
        case 'IE0022':
          paymentMethod = this.generateCustomizeString('wechatMobileOnline')
          break
        case 'IE0023':
          paymentMethod = this.generateCustomizeString('wechatPremiumPay')
          break
        case 'IE0031':
          paymentMethod = this.generateCustomizeString('unionpay')
          break
        case 'IE0036':
          paymentMethod = 'Union Secure Pay'
          break
        case 'IE0041':
          paymentMethod = this.generateCustomizeString('PoliPay')
          break
        case 'IE8888':
          paymentMethod = this.generateCustomizeString('creditPay')
          break
        case 'IE9999':
          paymentMethod = this.generateCustomizeString('bankTransfer')
          break
        case 'IE0111':
          paymentMethod = this.generateCustomizeString('paypal')
      }
      return paymentMethod
    },
    viewPaymentDetail() {
      this.dialogPaymentDetailVisible = !this.dialogPaymentDetailVisible
      const data = []
      if (this.orderTransaction.length > 0) {
        for (var j = 0; j < this.orderTransaction.length; j++) {
          var sobj = {}
          sobj.paymentNo = this.orderTransaction[j].out_trade_no
          sobj.createdTime = this.orderTransaction[j].created_at
          if (this.orderTransaction[j].finished_at) {
            sobj.paymentTime = this.orderTransaction[j].finished_at
          }
          sobj.paymentType = this.getPaymentMethod(
            this.orderTransaction[j].pay_type
          )
          sobj.paymentFee =
            'NZD $' + parseFloat(this.orderTransaction[j].fee / 100).toFixed(2)
          switch (this.orderTransaction[j].status) {
            case 0:
              sobj.paymentStatus = this.generateCustomizeString('unpaidOrders')
              break
            case 1:
              sobj.paymentStatus = this.generateCustomizeString('alreadyPaid')
              break
            case 2:
              sobj.paymentStatus = this.generateCustomizeString(
                'refundFinishedOrders'
              )
              break
            case 99:
              sobj.paymentStatus = this.generateCustomizeString('closedOrders')
              break
          }

          data[j] = sobj
        }
      }
      this.paymentDetail = data
    },
    fetchOrderInfo() {
      this.orderAddressTable = []
      this.orderSenderTable = []
      this.orderTimeTable = []
      this.orderFeeData = []
      this.orderFeeDetail = []
      this.orderActivityData = []
      return new Promise((resolve, reject) => {
        const that = this
        request({
          url: 'order/' + this.$route.params.orderId,
          method: 'get'
        })
          .then(response => {
            const orderTransactionData = response.data.transactions
            const orderAddressData = response.data.order_address
            const orderSenderData = response.data.order_sender
            var orderFeeDetailData = {}
            if (response.data.is_agent_order === true) {
              orderFeeDetailData = response.data.order_cost_fee_detail
            } else {
              orderFeeDetailData = response.data.order_fee_detail
            }
            var orderActivity = {}
            if (orderFeeDetailData) {
              orderActivity = orderFeeDetailData.detail_json
            }

            that.orderDetailData = response.data

            if (orderAddressData) {
              this.orderAddressTable.push(orderAddressData)
            }
            if (orderSenderData) {
              this.orderSenderTable.push(orderSenderData)
            }

            // Order time
            const orderTime = {}
            orderTime.created_at = response.data.created_at
            orderTime.paid_at = response.data.paid_at
            orderTime.delivery_at = response.data.delivery_at
            orderTime.finished_at = response.data.finished_at
            this.orderTimeTable.push(orderTime)

            this.orderTransaction = orderTransactionData
            for (var i = 0; i < this.orderTransaction.length; i++) {
              const transaction = this.orderTransaction[i]
              if (
                this.poliPaidTransaction === null &&
                transaction.pay_type === 'IE0041' &&
                transaction.status === 1
              ) {
                this.poliPaidTransaction = transaction
              }
              if (this.orderTransaction[i].status === 1) {
                this.isAgentRefundNo = this.orderTransaction[i].out_trade_no
                this.isAgentPayType = this.orderTransaction[i].pay_type
                break
              }
            }

            if (orderAddressData) {
              this.orderAddress = orderAddressData
            }
            this.orderSender = orderSenderData
            this.status = response.data.status

            if (
              response.data.customer.wechat_auths.length &&
              response.data.customer.wechat_auths[0].user_info
            ) {
              this.wechatDetail =
                response.data.customer.wechat_auths[0].user_info
            }

            // Order fee details
            const orderFeeDetailDataTmp = {}
            if (orderFeeDetailData) {
              orderFeeDetailDataTmp.total_goods_fee =
                'NZD $' +
                parseFloat(
                  (orderFeeDetailData.total_goods_fee * 100) / 10000
                ).toFixed(2)
              orderFeeDetailDataTmp.total_activity_reduction =
                'NZD $' +
                parseFloat(
                  (orderFeeDetailData.total_activity_reduction * 100) / 10000
                ).toFixed(2)
              orderFeeDetailDataTmp.total_goods_fee_after_discounted =
                'NZD $' +
                parseFloat(
                  (orderFeeDetailData.total_goods_fee_after_discounted * 100) /
                    10000
                ).toFixed(2)
              orderFeeDetailDataTmp.total_express_fee =
                'NZD $' +
                parseFloat(
                  (orderFeeDetailData.total_express_fee * 100) / 10000
                ).toFixed(2)
              orderFeeDetailDataTmp.total_express_fee_after_discounted =
                'NZD $' +
                parseFloat(
                  (orderFeeDetailData.total_express_fee_after_discounted *
                    100) /
                    10000
                ).toFixed(2)
              orderFeeDetailDataTmp.total_express_fee_reduction = parseFloat(
                ((orderFeeDetailData.total_express_fee -
                  orderFeeDetailData.total_express_fee_after_discounted) *
                  100) /
                  10000
              ).toFixed(2)
              orderFeeDetailDataTmp.total_coupon_reduction =
                'NZD $' +
                parseFloat(
                  (orderFeeDetailData.total_coupon_reduction * 100) / 10000
                ).toFixed(2)
              orderFeeDetailDataTmp.total_fee_after_discounted =
                'NZD $' +
                parseFloat(
                  (orderFeeDetailData.total_fee_after_discounted * 100) / 10000
                ).toFixed(2)
              orderFeeDetailDataTmp.profit =
                'NZD $' +
                parseFloat((response.data.profit * 100) / 10000).toFixed(2)
              orderFeeDetailDataTmp.fee =
                'NZD $' +
                parseFloat((response.data.fee * 100) / 10000).toFixed(2)
              orderFeeDetailDataTmp.use_activity_list = []
              orderFeeDetailDataTmp.use_coupon_list = []
              if (orderFeeDetailData.detail_json) {
                orderFeeDetailDataTmp.use_activity_list =
                  orderFeeDetailData.detail_json.use_activity_list
                orderFeeDetailDataTmp.use_coupon_list =
                  orderFeeDetailData.detail_json.use_coupon_list
              }
            }
            this.orderFeeDetail.push(orderFeeDetailDataTmp)
            this.orderActivityData.push(orderActivity)

            // OrderFees
            const orderFeeData = {}
            orderFeeData.goods_fee_before_discounted =
              'NZD $' +
              parseFloat(
                (response.data.goods_fee_before_discounted * 100) / 10000
              ).toFixed(2)
            orderFeeData.goods_fee =
              'NZD $' +
              parseFloat((response.data.goods_fee * 100) / 10000).toFixed(2)
            orderFeeData.express_fee_before_discounted =
              'NZD $' +
              parseFloat(
                (response.data.express_fee_before_discounted * 100) / 10000
              ).toFixed(2)
            orderFeeData.express_fee =
              'NZD $' +
              parseFloat((response.data.express_fee * 100) / 10000).toFixed(2)
            orderFeeData.fee =
              'NZD $' + parseFloat((response.data.fee * 100) / 10000).toFixed(2)
            this.orderFeeData.push(orderFeeData)

            // Expresses
            const orderExpresses = []
            if (response.data.expresses.length > 0) {
              for (var e = 0; e < response.data.expresses.length; e++) {
                var eobj = {}
                if (
                  response.data.expresses[e].express_company &&
                  response.data.expresses[e].express_company_id > 0
                ) {
                  eobj.expressCompanyId =
                    response.data.expresses[e].express_company_id
                  eobj.expressCompany =
                    response.data.expresses[e].express_company.name
                  eobj.queryUrl =
                    response.data.expresses[e].express_company.order_query_url
                } else {
                  eobj.expressCompanyId = null
                  eobj.expressCompany = ''
                  eobj.queryUrl = ''
                }
                eobj.expressNumber = response.data.expresses[e].express_number

                orderExpresses[e] = eobj
              }
            }
            this.orderExpressData = orderExpresses

            // Product Data
            const order_goods = response.data.order_goods
            const data = order_goods

            for (let i = 0; i < order_goods.length; i++) {
              var obj = {}
              let thumbnailUrl = null
              if (order_goods[i].sku_image_url) {
                thumbnailUrl = order_goods[i].sku_image_url
              } else {
                thumbnailUrl = order_goods[i].first_image_url
              }
              obj.productThumbnailUrl = thumbnailUrl + '?imageView2/0/w/128/h/128/q/75|imageslim'
              obj.productTitle = order_goods[i].product_full_name
              obj.productAbbreviation = order_goods[i].productAbbreviation
              obj.productId = order_goods[i].bar_code
              if (order_goods[i].best_use_before_at !== null) {
                obj.bestBefore = order_goods[i].best_use_before_at
              } else {
                obj.bestBefore = this.generateCustomizeString('Latest')
              }
              obj.unitPrice =
                'NZD $' +
                parseFloat(order_goods[i].order_price / 100).toFixed(2)
              obj.amount = order_goods[i].quantity
              obj.total =
                'NZD $' +
                parseFloat(
                  (order_goods[i].order_price * order_goods[i].quantity) / 100
                ).toFixed(2)

              data[i] = obj
            }
            this.orderProductData = data

            // images
            this.imageList = []
            this.imgListKey = []

            const images = response.data.images
            for (let i = 0; i < images.length; i++) {
              this.imageList.push(images[i].image_url)
              this.imgListKey.push(images[i].qiniu_res_key)
            }

            // Operation Log
            if (response.data.order_operation_logs) {
              const logData = response.data.order_operation_logs
              for (
                let i = 0;
                i < response.data.order_operation_logs.length;
                i++
              ) {
                var sobj = {}
                sobj.operator = response.data.order_operation_logs[i].operator
                sobj.operatingTime =
                  response.data.order_operation_logs[i].created_at
                sobj.operationalAttributes = this.getOperationStatus(
                  response.data.order_operation_logs[i].status
                )
                sobj.operationDetails =
                  response.data.order_operation_logs[i].message
                sobj.operationNotes =
                  response.data.order_operation_logs[i].comments

                logData[i] = sobj
              }
              this.orderOperationLog = logData.reverse()

              // Order Operation
              for (const i in that.orderOperationForm) {
                that.orderOperationForm[i] = response.data[i]
                that.orderOperationForm.goods_fee =
                  ((response.data.goods_fee / 100) * 1000) / 1000
                that.orderOperationForm.express_fee =
                  ((response.data.express_fee / 100) * 1000) / 1000
                if (response.data.status >= 90) {
                  that.orderOperationForm.status = 97
                } else {
                  that.orderOperationForm.status = response.data.status
                }
                that.orderOperationForm.comments = ''
                that.orderOperationForm.refund_type = this.refund2OPM
                that.orderOperationForm.order_comment = response.data['comment']
              }
              that.orderStatusCopy = that.orderOperationForm.status
            }
            resolve()
          })
          .catch(error => {
            reject(error)
            console.warn(error)
          })
      })
    },
    fetchExpressCompany() {
      return new Promise((resolve, reject) => {
        request({
          url: '/express/shop/company/list',
          method: 'get'
        })
          .then(response => {
            const data = response.data

            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              obj.value = response.data[i].express_company_id
              obj.label = response.data[i].company.name
              obj.is_default = response.data[i].is_default
              data[i] = obj
            }
            this.expressCompanyOptions = data
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    updateOrderInfo() {
      console.log(this.orderOperationForm)
      if (this.orderDetailData.is_agent_order === true) {
        this.orderOperationForm.refund_type = this.refund2OPM
      }

      var data = {
        expresses: this.orderOperationForm.expresses,
        to_customer_message: this.orderOperationForm.to_customer_message,
        comments: this.orderOperationForm.comments
          ? this.orderOperationForm.comments
          : '',
        status: this.orderStatus,
        refund_type: this.orderOperationForm.refund_type,
        upload_image_keys: this.imgListKey,
        order_comment: this.orderOperationForm.order_comment
      }

      if (this.status === 0) {
        data['goods_fee'] = (this.orderOperationForm.goods_fee * 1000) / 10
        data['express_fee'] = (this.orderOperationForm.express_fee * 1000) / 10
      }

      request({
        url: 'order/' + this.$route.params.orderId,
        method: 'put',
        data
      })
        .then(response => {
          if (response.status === 40047) {
            this.dialogSubmitOrderInfoVisible = false
            this.$alert(
              this.generateCustomizeString('DirectionOnMyPayInsufficientFunds'),
              this.generateCustomizeString('MyPayRefundFailedInsufficientFunds'), {
                confirmButtonText: 'Confirm',
                dangerouslyUseHTMLString: true
              })
            return
          } else if (response.status === 40049) {
            this.dialogSubmitOrderInfoVisible = false
            this.$alert(
              this.generateCustomizeString('DirectionOnPayPalInsufficientFunds'),
              this.generateCustomizeString('PayPalRefundFailedInsufficientFunds'), {
                confirmButtonText: 'Confirm',
                dangerouslyUseHTMLString: true
              })
            return
          }
          if (response.data.order_operation_logs) {
            const data = []
            for (
              let i = 0;
              i < response.data.order_operation_logs.length;
              i++
            ) {
              var obj = {}
              obj.operator = response.data.order_operation_logs[i].operator
              obj.operatingTime =
                response.data.order_operation_logs[i].created_at
              obj.operationalAttributes = this.getOperationStatus(
                response.data.order_operation_logs[i].status
              )
              obj.operationDetails =
                response.data.order_operation_logs[i].message
              obj.operationNotes =
                response.data.order_operation_logs[i].comments

              data[i] = obj
            }
            // this.orderOperationLog = data
          }
          this.orderDetailData.goods_fee = response.data.goods_fee
          this.orderDetailData.express_fee = response.data.express_fee

          if (response.status === 0) {
            this.dialogSubmitOrderInfoVisible = false
            if (this.orderOperationForm.refund_type == this.refund2OPM &&
              this.poliPaidTransaction &&
              this.orderStatus == 60
            ) {
              // alert会弹窗
              this.$alert(
                this.generateCustomizeString('poliPayRefundOperation') + this.poliPaidTransaction.fee / 100 + 'NZD',
                this.generateCustomizeString('OrderDetailSaved'), {
                  confirmButtonText: 'OK',
                  dangerouslyUseHTMLString: true
                })
            } else {
              this.$message.success(this.generateCustomizeString('OrderDetailSaved'))
            }
            this.fetchOrderInfo()
          } else {
            this.dialogSubmitOrderInfoVisible = false
            this.$message.error(
              this.generateCustomizeString('OrderDetailSaveFailed')
            )
          }
        })
        .catch(error => {
          console.log(error)
          this.dialogSubmitOrderInfoVisible = false
          this.$message.error(
            this.generateCustomizeString('OrderDetailSaveFailed')
          )
        })
    },
    fetchUploadToken() {
      return new Promise((resolve, reject) => {
        request({
          url: '/upload-token',
          method: 'get'
        })
          .then(res => {
            this.qiniuData.token = res.data['token']
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    updateAddressClick() {
      var data = {
        consignee_name: this.orderAddress.consignee_name,
        phone: this.orderAddress.phone,
        person_id: this.orderAddress.person_id,
        country: this.orderAddress.country,
        state: this.orderAddress.state,
        city: this.orderAddress.city,
        district: this.orderAddress.district,
        shipping_address: this.orderAddress.shipping_address
      }
      // var id = this.orderAddress.id
      request({
        url: 'order/' + this.$route.params.orderId + '/order-address',
        method: 'put',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('OrderAddressSaved'),
              type: 'success'
            })
          } else {
            this.$message.error(
              this.generateCustomizeString('OrderAddressSaveFailed')
            )
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(
            this.generateCustomizeString('OrderAddressSaveFailed')
          )
        })
        .finally(() => {
          this.dialogEditAddressVisible = false
          this.fetchOrderInfo()
        })
    },
    writeOffClick() {
      this.writeOffDialogVisible = true
      this.writeOffForm.id = this.orderDetailData.id
    },
    writeOffConfirm() {
      var data = {
        order_id: this.writeOffForm.id
      }
      request({
        url: '/write-off',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('writeOffSuccessfully'),
              type: 'success'
            })
            this.fetchOrderData(this.currentPage)
          } else {
            this.$message.error(this.generateCustomizeString('writeOffFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('writeOffFailed'))
        })
        .finally(() => {
          this.writeOffDialogVisible = false
          this.writeOffForm.id = ''
        })
    }
  },
  created() {
    this.pageLoading = true
    this.fetchExpressCompany()
      .then(result => {})
      .catch(error => {
        console.warn(error)
      })
      .finally(() => {
        Promise.all([this.fetchUploadToken(), this.fetchOrderInfo()])
          .then(result => {})
          .catch(error => {
            console.warn(error)
          })
          .finally(() => {
            this.pageLoading = false
          })
      })
    if (!this.isEdit) {
      // this.fetchOrderOperationLog()
      this.orderOperationForm = Object.assign({}, defaultOrderOperation)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.bottom {
  margin-top: 13px;
  line-height: 12px;
}
.demo-userForm {
  padding: 50px 50px 0px 0px;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.order-data {
  padding: 30px 0;
  border-radius: 10px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  background-color: #fdfdfd;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  min-height: 60px;
  margin: 0 auto;
  flex: auto;
  overflow: auto;
  -webkit-align-items: center;
  align-items: center;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.title-label {
  display: inline-block;
  text-align: right;
  width: 160px;
}
.title-label2 {
  display: inline-block;
  text-align: right;
  width: 130px;
}
.content-label {
  padding: 0px 0px 0px 10px;
}
.card-img {
  position: relative;
  height: 180px;
  overflow: hidden;
}
.card-img img {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: auto;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.button {
  padding: 0;
  padding-left: 6px;
  float: right;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}
</style>
<style type="text/css">
.el-select-dropdown {
  z-index: 1000001 !important;
}
.alert-warning {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}
.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: transparent;
  border-radius: 0.25rem;
}
.display-notice {
  font-size: 10px;
  color: red;
}
.polipay-refund2OPM-alert {
    padding: 6px;
    background-color: #fff6f7;
    border-radius: 4px;
    font-size: .8rem;
    width: fit-content;
}
</style>
